a {
  text-decoration: none;
}

.button {
  width: auto;
  font-size: 16px;
}

.hidden {
  display: none;
}

.document {
  position: absolute;
  left: 1px /*rtl:ignore*/;
  right: 0 /*rtl:ignore*/;
  bottom: 0;
  max-height: 59px;
  transition: max-height 0.3s linear;
  overflow: hidden;
}

.document.open {
  max-height: 100%;
  z-index: 3;
}

.button-document {
  display: flex;
  justify-content: center;
  width: 100%;
  cursor: pointer;
  background-color: #ffffff;
}

.button-document:active {
  background-color: #cbcbcb;
}

.button-document.open:hover {
  background-color: #e6e6e6;
}

.grid-view .button-document {
  padding: 12px 10px 16px;
}

.grid-view.open .button-document {
  padding: 12px 10px 6px;
}

.document-list {
  background-color: #ffffff;
}

.document-item {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 10px 20px 10px 20px;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  cursor: pointer;
}

.document-item:hover, .document-item:focus {
  background-color: #e6e6e6;
}

.icon-file {
  top: -2px;
  width: 20px;
  height: 20px;
  background-size: 100%;
  background-repeat: no-repeat;
  flex-shrink: 0;
}

:host(:not([dir="rtl"])) .icon-file {
  margin-right: 5px;
}

:host([dir="rtl"]) .icon-file {
  margin-left: 5px;
}

.icon-doc, .icon-cad {
  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='60px' height='60px' viewBox='0 0 60 60' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 63.1 (92452) - https://sketch.com --%3E%3Ctitle%3EIcon/Documents/Filled/CAD%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Icon/Documents/Filled/CAD' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Crect id='bound' x='0' y='0' width='60' height='60'%3E%3C/rect%3E%3Cg id='bg' transform='translate(10.000000, 0.000000)' fill-rule='nonzero'%3E%3Cpolygon id='Rectangle-15' fill='%23404040' points='0 1.56437363e-14 26 0 40 14 40 60 0 60'%3E%3C/polygon%3E%3Cpolygon id='Rectangle-16' fill='%23000000' points='26 0 40 14 26 14'%3E%3C/polygon%3E%3C/g%3E%3Cpath d='M29,42 L22.0285645,42 L22.0285645,35 L16,35 L16,31.9875488 L22.0285645,31.9875488 L22.0285645,25 L28.9902344,25 L28.9902344,19 L32.0454102,19 L32,25 L39,25 L39,32 L44.9958496,31.9875488 L44.9958496,35 L39,35 L39,42 L32,42 L32,48 L29,48 L29,42 Z M25,39 L36,39 L36,28 L25,28 L25,39 Z' id='img' fill='%23FFFFFF' fill-rule='nonzero'%3E%3C/path%3E%3C/g%3E%3C/svg%3E");
}

.icon-pdf {
  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='60px' height='60px' viewBox='0 0 60 60' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 63.1 (92452) - https://sketch.com --%3E%3Ctitle%3EIcon/Documents/Filled/pdf%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Icon/Documents/Filled/pdf' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Crect id='bound' x='0' y='0' width='60' height='60'%3E%3C/rect%3E%3Cg id='bg' transform='translate(10.000000, 0.000000)' fill-rule='nonzero'%3E%3Cpolygon id='Rectangle-15' fill='%23C22827' points='0 1.56437363e-14 26 0 40 14 40 60 0 60'%3E%3C/polygon%3E%3Cpolygon id='Rectangle-16' fill='%23680F11' points='26 0 40 14 26 14'%3E%3C/polygon%3E%3C/g%3E%3Cpath d='M46.4496479,36.9428356 C46.6915555,37.1843563 46.9152007,37.5380396 46.951152,37.8240149 C47.071819,38.7879483 46.9816534,39.72941 46.5372319,40.4128392 C46.3114831,40.7602696 45.9411636,41.016348 45.5018098,41.1352522 C45.2168749,41.2122418 44.8662522,41.2519089 44.4595031,41.2519089 C42.1686474,41.2519089 38.5390763,40.0726389 35.5879943,38.3746664 C31.7155593,38.9665486 27.2970634,40.0396158 23.4162143,41.330657 C20.0549409,47.3247088 17.6149245,50 15.5131964,50 C15.1209809,50 14.7381357,49.905815 14.375083,49.7199846 L13.538159,49.2896048 C13.0131333,48.9829166 12.9362583,48.3206888 13.0395233,47.8031581 C13.3639473,46.1812959 15.3193834,44.1374563 18.2702744,42.3370913 C18.6181242,42.1220478 20.1011233,41.3205937 20.164134,41.2865933 L21.0294559,40.8190865 C21.8675273,39.3538415 22.7920352,37.6242129 23.8109158,35.5867241 L23.9368417,35.3345536 C24.9053329,33.3959396 26.0030008,31.1985114 26.878936,29.0166182 L27.1920773,28.238808 C25.9687704,23.4633026 25.2937237,19.7762037 25.9479262,17.3115591 C26.1631571,16.5257374 26.9830615,16 27.989034,16 L28.0035676,16 L28.5326091,16.0174888 C29.434743,15.9775284 30.0101581,16.7103953 30.3036026,17.4020317 L30.397306,17.6480467 C30.4737029,17.8737396 30.4978937,17.9579592 30.5371917,18.2483312 C30.8227957,20.3655455 29.7438685,26.6275953 29.7438685,26.6275953 C29.6924272,26.8612997 29.6371614,27.0903145 29.5722383,27.3508871 C30.5685537,30.1405882 32.167439,32.6775328 34.0829078,34.5052545 C34.7950534,35.1852644 35.7020636,35.749985 36.5822059,36.2688832 C38.5477772,35.9876953 40.41649,35.8479805 41.9690973,35.8654694 C44.2627261,35.8962459 45.7700117,36.2586243 46.4496479,36.9428356 Z M15.1035448,48.301832 C16.136959,47.8239688 17.707829,46.3002976 20.0535683,42.477392 C19.735455,42.7862296 19.3880832,43.118907 19.2470501,43.2357593 C17.0039064,45.114091 15.4867724,47.2310119 15.1035448,48.301832 Z M28.3898199,17.0747281 C28.0797383,17.0747281 28.1079449,19.5457234 28.1079449,19.5457234 C28.1079449,20.8384258 28.2933437,22.815437 28.6769538,24.0697423 C29.1401161,23.2225636 29.5134953,22.0775873 29.4816553,20.4461501 C29.4497196,18.8148106 29.0654403,17.0747281 28.3898199,17.0747281 Z M24.3782653,39.2992256 C26.9631394,38.2839986 29.8990187,37.4487393 33.2958612,36.7619879 C33.0639932,36.581336 32.8432166,36.4001956 32.63487,36.220032 C30.9644642,34.7752067 29.5435196,32.9719106 28.4025378,30.850788 C27.8288438,32.3666433 27.0585639,34.2108767 25.8388903,36.5677554 C25.3385335,37.5305164 24.8488856,38.4383684 24.3782653,39.2992256 Z M45.8395859,39.182184 C46.0464025,39.0499927 46.0311997,38.4112133 44.8245298,38.0967089 C43.61786,37.7822041 43.2523212,37.7876696 42.0183055,37.7876696 C41.3441195,37.7876696 40.5922935,37.8191359 39.7723889,37.8811771 C41.9063394,38.8159949 43.4285412,39.3907791 44.6588281,39.3907791 C45.0400477,39.3907791 45.6326735,39.3143757 45.8395859,39.182184 Z' id='img' stroke='%23FFFFFF' stroke-width='0.100000001' fill='%23FFFFFF' fill-rule='nonzero'%3E%3C/path%3E%3C/g%3E%3C/svg%3E");
}

:host(:not([dir="rtl"])) .link-all {
  padding: 10px 20px 10px 24px;
}

:host([dir="rtl"]) .link-all {
  padding: 10px 24px 10px 20px;
}

.document-backdrop {
  position: absolute;
  top: 1px;
  height: 0;
  width: calc(100% - 1px);
  z-index: 3;
  transition: height 0s linear 0.3s, background-color 0.3s linear;
  background-color: unset;
}

:host(:not([dir="rtl"])) .document-backdrop {
  left: 1px;
}

:host([dir="rtl"]) .document-backdrop {
  right: 1px;
}

.document-backdrop.open {
  height: calc(100% - 1px);
  background-color: rgba(51, 51, 51, 0.2);
  transition: background-color 0.3s linear;
}

@media screen and (min-width: 980px) {
  .document.list-view {
    position: relative;
    background-color: #ffffff;
    border-top: none;
    overflow: visible;
  }

  .document.list-view .button-document {
    background-color: #ffffff;
  }

  .document.list-view .button-document:hover, .document.list-view .button-document:active {
    border-color: #626469;
    background-color: #ffffff;
  }

  .document.list-view .button-document.open {
    box-shadow: none;
  }

  :host(:not([dir="rtl"])) .document.list-view .icon-documents {
    margin-right: 3px;
  }

  :host([dir="rtl"]) .document.list-view .icon-documents {
    margin-left: 3px;
  }

  .document.list-view .document-list {
    display: none;
    position: absolute;
    z-index: 5;
    top: calc(100% + 5px);
    width: 300px;
    background-color: #ffffff;
  }

  :host(:not([dir="rtl"])) .document.list-view .document-list {
    right: 0;
  }

  :host([dir="rtl"]) .document.list-view .document-list {
    left: 0;
  }

  .document.list-view .open .icon-arrow-up {
    display: block;
  }

  .document.list-view .open .icon-arrow-down {
    display: none;
  }

  .document.list-view .open + .document-list {
    display: block;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  }

  .document-backdrop.list-view {
    display: none;
  }
}